import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProsp {
  title: string;
  description?: string;
}

export default function SEO({ title, description }: SEOProsp) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
